import React, { useEffect, useState, useContext, useRef, useCallback } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Form, Input, Icon, Row, Col, DatePicker, TimePicker, Checkbox, notification, Select, Modal, Upload, Switch, Tooltip } from "antd";
import { GlobalContext } from "../../../app/providers/GlobalState";
import moment from "moment";
import axios from "axios";

import { calculateWorkload } from "../../../shared/utils/Diario/timeUtils";

const { Option } = Select;
const { TextArea } = Input;
const Dragger = Upload.Dragger;
const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Detalhe = ({ aulaId, cargaAcima, duplicada, foraPeriodo, extracurricular, codigoMultisseriado, form, match, confirmarAula }) => {
    const [loading, setLoading] = useState(false);
    const [intervalos, setIntervalos] = useState({
        inicio: null,
        termino: null
    });
    const [data, setData] = useState(null);
    const [horaInicio, setHoraInicio] = useState(null);
    const [horaTermino, setHoraTermino] = useState(null);
    const [cargaHoraria, setCargaHoraria] = useState(undefined);
    const [dataComp, setDataComp] = useState(null);
    const [horaInicioComp, setHoraInicioComp] = useState(null);
    const [horaTerminoComp, setHoraTerminoComp] = useState(null);
    const [cargaHorariaComp, setCargaHorariaComp] = useState(undefined);
    const [listaProfessores, setListaProfessores] = useState([]);
    const [professorId, setProfessorId] = useState(undefined);
    const [listaSalas, setListaSalas] = useState([]);
    const [salaId, setSalaId] = useState(undefined);
    const [observacoes, setObservacoes] = useState("");
    const [aulaAvaliacao, setAulaAvaliacao] = useState(false);
    const [aulaExtracurricular, setAulaExtracurricular] = useState(false);
    const [falta, setFalta] = useState(false);
    const [reorganizacao, setReorganizacao] = useState(false);
    const [guardarRecorrencia, setGuardarRecorrencia] = useState(false);
    const [codigoRecorrencia, setCodigoRecorrencia] = useState(undefined);
    const [motivo, setMotivo] = useState("");
    const [permissao, setPermissao] = useState(false);
    const [editar, setEditar] = useState(false);
    const [reagendar, setReagendar] = useState(false);
    const [reagendada, setReagendada] = useState(false);
    const [ficheiro, setFicheiro] = useState("");
    const [backup, setBackup] = useState({
        data: null,
        horaInicio: null,
        horaTermino: null,
        cargaHoraria: undefined,
        dataComp: null,
        horaInicioComp: null,
        horaTerminoComp: null,
        cargaHorariaComp: undefined,
        professorId: undefined,
        salaId: undefined,
        observacoes: "",
        aulaAvaliacao: false,
        aulaExtracurricular: false,
        falta: false,
        codigoRecorrencia: codigoRecorrencia,
        motivo: ""
    });
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const autoSaveTimeoutRef = useRef(null);
    const bloquearDebounceRef = useRef(false);
    const alteradoPeloUserRef = useRef(false);
    const rascunhoCarregadoRef = useRef(false);
    const originaisRef = useRef();

    const globalContext = useContext(GlobalContext);

    const backupRascunhoRef = useRef({
        data: null,
        horaInicio: null,
        horaTermino: null,
        dataComp: null,
        horaInicioComp: null,
        horaTerminoComp: null,
        professorId: null,
        salaId: null,
        observacoes: "",
        aulaAvaliacao: false,
        aulaExtracurricular: false,
        falta: false,
        guardarRecorrencia: false,
        reorganizacao: false,
        motivo: "",
        reagendar: false
    });

    const { getFieldDecorator } = form;

    const handleChangeHoraInicio = horaInicio => {
        alteradoPeloUserRef.current = true;
        form.resetFields();
        setHoraInicio(horaInicio);
        setHoraTermino(moment(horaInicio).add(1, "hour"));
    };

    const handleChangeHoraInicioComp = horaInicio => {
        alteradoPeloUserRef.current = true;

        form.resetFields();
        setHoraInicioComp(horaInicio);
        setHoraTerminoComp(moment(horaInicio).add(1, "hour"));
    };

    const listarProfessores = () => {
        axios({
            method: "get",
            url: "/api/aulas/listar-professores-detalhe-aula",
            params: {
                aulaId: aulaId
            }
        })
            .then(response => {
                setListaProfessores(response.data);
            })
            .catch(() => {});
    };

    const listarSalas = () => {
        axios({
            method: "get",
            url: "/api/aulas/listar-salas",
            params: {
                estabelecimentoId: globalContext.estabelecimento?.id
            }
        })
            .then(response => {
                setListaSalas(response.data);
            })
            .catch(() => {});
    };

    const validarPermissao = async () => {
        try {
            const { data } = await axios.get("/api/aulas/validar-permissao-aula", {
                params: { aulaId }
            });

            const { perfil } = globalContext;
            const permissoesEspeciais = ["Suporte", "Gestor", "Administrativo"];

            setPermissao(data || permissoesEspeciais.includes(perfil?.nome));
        } catch (error) {
            console.error("Erro ao validar permissão", error);
        }
    };

    const carregarDetalhe = () => {
        axios({
            method: "get",
            url: "/api/aulas/detalhe",
            params: {
                aulaId
            }
        })
            .then(response => {
                form.resetFields();

                const evento = response.data;

                setBackup({
                    data: moment(evento.dt_inicio),
                    horaInicio: moment(evento.hr_inicio, "HH:mm"),
                    horaTermino: moment(evento.hr_termino, "HH:mm"),
                    cargaHoraria: evento.carga_horaria ?? undefined,

                    dataComp: evento.dt_inicio_reagendada ? moment(evento.dt_inicio_reagendada) : null,
                    horaInicioComp: evento.hr_inicio_reagendada ? moment(evento.hr_inicio_reagendada, "HH:mm") : null,
                    horaTerminoComp: evento.hr_termino_reagendada ? moment(evento.hr_termino_reagendada, "HH:mm") : null,
                    cargaHorariaComp: evento.carga_horaria_reagendada ?? undefined,

                    professorId: evento.id_professor ?? undefined,
                    salaId: evento.id_sala ?? undefined,
                    observacoes: evento.titulo ?? "",
                    aulaAvaliacao: !!evento.avaliacao,
                    aulaExtracurricular: !!evento.extracurricular,
                    falta: !!evento.falta,
                    guardarRecorrencia: false, // ou evento.recorrencia se fizer sentido
                    reorganizacao: false, // idem
                    motivo: evento.motivo ?? ""
                });

                setData(moment(evento.dt_inicio));
                setHoraInicio(moment(evento.hr_inicio, "HH:mm"));
                setHoraTermino(moment(evento.hr_termino, "HH:mm"));

                if (evento.carga_horaria) setCargaHoraria(evento.carga_horaria);
                if (evento.dt_inicio_reagendada) setDataComp(moment(evento.dt_inicio_reagendada));
                if (evento.hr_inicio_reagendada) setHoraInicioComp(moment(evento.hr_inicio_reagendada, "HH:mm"));
                if (evento.hr_termino_reagendada) setHoraTerminoComp(moment(evento.hr_termino_reagendada, "HH:mm"));
                if (evento.carga_horaria_reagendada) setCargaHorariaComp(evento.carga_horaria_reagendada);
                setProfessorId(evento.id_professor ? evento.id_professor : undefined);
                if (evento.motivo) setMotivo(evento.motivo);

                setSalaId(evento.id_sala);
                setObservacoes(evento.titulo);
                setAulaAvaliacao(evento.avaliacao);
                setAulaExtracurricular(evento.extracurricular);
                setFalta(evento.falta);
                setCodigoRecorrencia(evento.recorrencia);

                setReagendada(
                    evento.dt_inicio_reagendada != null &&
                        evento.hr_inicio_reagendada != null &&
                        evento.hr_termino_reagendada != null &&
                        evento.carga_horaria_reagendada != null
                );

                const fichs = evento.ficheiros.map(file => ({
                    uid: file.id,
                    name: file.nome,
                    status: "done",
                    url: file.url
                }));
                setFicheiro(fichs);
                originaisRef.current = evento;
                if (!rascunhoCarregadoRef.current) {
                    rascunhoCarregadoRef.current = true;
                    carregarRascunhoAula(evento);
                }
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
            });
    };

    const guardar = multisseriado => {
        if (falta) marcarFalta(multisseriado);
        else alterar(false, multisseriado);
    };

    const marcarFalta = multisseriado => {
        if (setProfessorId != null && professorId != null)
            confirm({
                title: "Pretende marcar falta para esta aula? Os dados que possam existir nesta aula não serão contabilizados, como por exemplo as frequências.",
                okText: "Confirmar",
                okType: "Cancelar",
                onOk: () => {
                    alterar(false, multisseriado);
                }
            });
        else openNotificationWithIcon("error", "Erro", "Para marcar a aula com falta precisa ser selecionado o professor");
    };

    const confirmar = () => {
        let texto = "Atenção que ao confirmar esta aula poderá ficar com frequências duplicadas.";
        if (foraPeriodo) texto = "Atenção que ao confirmar poderá haver incoerências na frequencia.";

        confirm({
            title: texto,
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/aulas/confirmar-aula",
                    params: {
                        aulaId: aulaId
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Aula confirmada!");
                        confirmarAula();
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível confirmar aula.");
                    });
            }
        });
    };

    const validarFormatos = (formato, formatos_aceites) => {
        var valido = false;

        for (var i = 0; i < formatos_aceites.length; i++) {
            if (formato === formatos_aceites[i]) valido = true;
        }

        return valido;
    };

    const validar = (rule, value, callback) => {
        if (value.file)
            if (
                !validarFormatos(value.file.name.split(".").pop().toLowerCase(), [
                    "zip",
                    "rar",
                    "7z",
                    "docx",
                    "doc",
                    "pdf",
                    "odf",
                    "txt",
                    "rtf",
                    "xlsx",
                    "xls",
                    "csv",
                    "ods",
                    "pptx",
                    "ppt",
                    "odp",
                    "bmp",
                    "gif",
                    "png",
                    "jpeg",
                    "jpg"
                ]) ||
                value.file.size > 26214400
            )
                callback("Campo obrigatório");

        callback();
    };

    const propsFileUpload = {
        accept: ".zip, .rar, .7z, .docx, .doc, .pdf, .odf, .txt, .rtf, .xlsx, .xls, .csv, .ods, .pptx, .ppt, .odp, .bmp, .gif, .png, .jpeg, .jpg",
        multiple: false,
        onRemove: file => {
            form.resetFields("download");
            setFicheiro([]);
        },
        defaultFileList: ficheiro,
        beforeUpload: file => {
            if (
                !validarFormatos(file.name.split(".").pop().toLowerCase(), [
                    "zip",
                    "rar",
                    "7z",
                    "docx",
                    "doc",
                    "pdf",
                    "odf",
                    "txt",
                    "rtf",
                    "xlsx",
                    "xls",
                    "csv",
                    "ods",
                    "pptx",
                    "ppt",
                    "odp",
                    "bmp",
                    "gif",
                    "png",
                    "jpeg",
                    "jpg"
                ])
            ) {
                openNotificationWithIcon("error", "Erro", "Ficheiro com formato inválido");
                return false;
            }

            if (file.size > 26214400) {
                openNotificationWithIcon("error", "Erro", "Limite de 25 MB por upload");
                return false;
            }

            setFicheiro([file]);

            return false;
        },
        ficheiro
    };

    const alterar = (confirmado, multisseriado) => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setLoading(true);

                var item = new FormData();
                item.append("id", aulaId);
                item.append("dt_inicio", data.format("YYYY/MM/DD"));
                item.append("hr_inicio", horaInicio.format("HH:mm"));
                item.append("hr_termino", horaTermino.format("HH:mm"));
                item.append("carga_horaria", cargaHoraria);
                if (dataComp) item.append("dt_inicio_reagendada", dataComp.format("YYYY/MM/DD"));
                if (horaInicioComp) item.append("hr_inicio_reagendada", horaInicioComp.format("HH:mm"));
                if (horaTerminoComp) item.append("hr_termino_reagendada", horaTerminoComp.format("HH:mm"));
                if (cargaHorariaComp) item.append("carga_horaria_reagendada", cargaHorariaComp);
                if (permissao && professorId) item.append("id_professor", professorId);
                if (salaId) item.append("id_sala", salaId);
                if (observacoes) item.append("titulo", observacoes);
                item.append("avaliacao", aulaAvaliacao);
                item.append("extracurricular", aulaExtracurricular);
                item.append("falta_prof", falta);
                item.append("falta_motivo_prof", motivo);
                item.append("isRecorrencia", guardarRecorrencia);
                item.append("reorganizacao", reorganizacao);
                item.append("reagendar", reagendar);
                item.append("ficheiro_nome", ficheiro[0]);
                if (confirmado) item.append("confirmado", confirmado);
                item.append("ficheiro_nome", ficheiro[0]);
                item.append("multisseriado", multisseriado);

                axios({
                    method: "put",
                    url: "/api/aulas/alterar-aula",
                    data: item
                })
                    .then(response => {
                        if (response.data) {
                            AlertarSobreposicao(response.data);

                            return null;
                        }

                        setLoading(false);
                        if (!reagendar || reagendada) {
                            openNotificationWithIcon("success", "Sucesso", "Aula atualizada!");
                            setEditar(false);
                        } else {
                            openNotificationWithIcon("success", "Sucesso", "Aula reagendada!");
                            //setRedirectLink(`/gerir-detalhe-turma/${match.params.curso}/horario-disciplina`);
                            setRedirectLink(localStorage.getItem("link_voltar_calendario"));
                            setRedirect(true);
                        }
                    })
                    .catch(error => {
                        if (!error.response.data) openNotificationWithIcon("error", "Erro", "Não foi possível alterar aula.");

                        openNotificationWithIcon("error", "Erro", error.response.data.mensagem);

                        setLoading(false);
                    });
            }
        });
    };

    const AlertarSobreposicao = mensagem => {
        confirm({
            title: mensagem,
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                alterar(true, false);
            },
            onCancel: () => {
                setLoading(false);
            }
        });
    };

    const apanharUltimaHora = (prevista, dataInicio) => {
        axios({
            method: "get",
            url: "/api/aulas/apanhar-ultima-hora-aula",
            params: {
                aulaId: aulaId,
                data: dataInicio.format("YYYY/MM/DD")
            }
        })
            .then(response => {
                form.resetFields();

                if (response.data.hr_inicio && response.data.hr_termino) {
                    if (prevista) {
                        setHoraInicio(moment(response.data.hr_inicio, "HH:mm"));
                        setHoraTermino(moment(response.data.hr_termino, "HH:mm"));
                    } else {
                        setHoraInicioComp(moment(response.data.hr_inicio, "HH:mm"));
                        setHoraTerminoComp(moment(response.data.hr_termino, "HH:mm"));
                    }
                } else {
                    if (prevista) {
                        setHoraInicio(moment(response.data, "HH:mm"));
                        setHoraTermino(moment(response.data, "HH:mm").add(1, "hour"));
                    } else {
                        setHoraInicioComp(moment(response.data, "HH:mm"));
                        setHoraTerminoComp(moment(response.data, "HH:mm").add(1, "hour"));
                    }
                }
            })
            .catch(() => {});
    };

    const calcularCargaHoraria = () => {
        const cargaHorariaFormatada = calculateWorkload(horaInicio, horaTermino);

        setCargaHoraria(cargaHorariaFormatada);

        //const inicio = horaInicio;
        //const termino = horaTermino;

        //const formatoHora = "HH:mm";
        //const inicioMoment = moment(inicio, formatoHora);
        //const terminoMoment = moment(termino, formatoHora);

        //const duracao = moment.duration(terminoMoment.diff(inicioMoment));

        //const minutosTotais = duracao.asMinutes();

        //const minutosMinimos = Math.max(minutosTotais, 60);

        //const minutosArredondados = Math.ceil(minutosMinimos / 30) * 30;

        //const cargaHorariaFormatada = moment.utc(minutosArredondados * 60000).format("HH:mm");

        //setCargaHoraria(cargaHorariaFormatada);
    };

    const calcularCargaHorariaComp = () => {
        const cargaHorariaFormatada = calculateWorkload(horaInicioComp, horaTerminoComp);

        setCargaHorariaComp(cargaHorariaFormatada);

        //const inicio = horaInicioComp;
        //const termino = horaTerminoComp;

        //const formatoHora = "HH:mm";
        //const inicioMoment = moment(inicio, formatoHora);
        //const terminoMoment = moment(termino, formatoHora);

        //const duracao = moment.duration(terminoMoment.diff(inicioMoment));

        //const minutosTotais = duracao.asMinutes();

        //const minutosMinimos = Math.max(minutosTotais, 60);

        //const minutosArredondados = Math.ceil(minutosMinimos / 30) * 30;

        //const cargaHorariaFormatada = moment.utc(minutosArredondados * 60000).format("HH:mm");

        //setCargaHorariaComp(cargaHorariaFormatada);
    };

    const criarBackup = () => {
        setBackup({
            data: data,
            horaInicio: horaInicio,
            horaTermino: horaTermino,
            cargaHoraria: cargaHoraria,
            dataComp: dataComp,
            horaInicioComp: horaInicioComp,
            horaTerminoComp: horaTerminoComp,
            cargaHorariaComp: cargaHorariaComp,
            professorId: professorId,
            salaId: salaId,
            observacoes: observacoes,
            aulaAvaliacao: aulaAvaliacao,
            aulaExtracurricular: aulaExtracurricular,
            falta: falta,
            guardarRecorrencia: guardarRecorrencia,
            motivo: motivo
        });
    };

    const usarBakcup = () => {
        form.resetFields();
        setData(backup.data);
        setHoraInicio(backup.horaInicio);
        setHoraTermino(backup.horaTermino);
        setCargaHoraria(backup.cargaHoraria);
        setDataComp(backup.dataComp);
        setHoraInicioComp(backup.horaInicioComp);
        setHoraTerminoComp(backup.horaTerminoComp);
        setCargaHorariaComp(backup.cargaHorariaComp);
        setProfessorId(backup.professorId);
        setSalaId(backup.salaId);
        setObservacoes(backup.observacoes);
        setAulaAvaliacao(backup.aulaAvaliacao);
        setAulaExtracurricular(backup.aulaExtracurricular);
        setFalta(backup.falta);
        setGuardarRecorrencia(backup.guardarRecorrencia);
        setMotivo(backup.motivo);
    };

    const cancelarRascunho = () => {
        axios({
            method: "delete",
            url: "/api/aulas/rascunho-detalhe-aula",
            params: { aulaId: localStorage.getItem("aula_diario") }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Rascunho descartado.");
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error?.data?.message || "Não foi possível descartar o rascunho.");
            });
    };

    const carregarRascunhoAula = detalheOriginal => {
        const aulaId = localStorage.getItem("aula_diario");
        if (!aulaId) return;

        bloquearDebounceRef.current = true;
        axios({
            method: "get",
            url: "/api/aulas/rascunho-detalhe-aula",
            params: { aulaId }
        })
            .then(response => {
                const detalhe_rascunhoAula = response.data;

                if (!detalhe_rascunhoAula) return;

                const isEmpty = v => v === null || v === undefined || (typeof v === "string" && v.trim() === "");

                const semRascunhoBase =
                    isEmpty(detalhe_rascunhoAula.dt_inicio_rascunho) ||
                    isEmpty(detalhe_rascunhoAula.hr_inicio_rascunho) ||
                    isEmpty(detalhe_rascunhoAula.hr_termino_rascunho);

                if (semRascunhoBase) return;

                // ✅ Só mostra o modal se houver diferença real
                confirm({
                    title: "Rascunho encontrado",
                    content: `Existe um rascunho guardado para esta aula a ${moment(detalhe_rascunhoAula.dt_detalhe_rascunho).format(
                        "DD/MM/YYYY [às] HH:mm"
                    )}. Deseja carregar os dados do rascunho?`,
                    okText: "Sim, carregar",
                    cancelText: "Não",
                    onOk: () => {
                        setData(moment(detalhe_rascunhoAula.dt_inicio_rascunho));
                        setHoraInicio(moment(detalhe_rascunhoAula.hr_inicio_rascunho, "HH:mm"));
                        setHoraTermino(moment(detalhe_rascunhoAula.hr_termino_rascunho, "HH:mm"));
                        setProfessorId(detalhe_rascunhoAula.id_professor_rascunho);
                        setSalaId(detalhe_rascunhoAula.id_sala_rascunho);
                        setObservacoes(detalhe_rascunhoAula.titulo_rascunho || "");
                        setAulaAvaliacao(detalhe_rascunhoAula.avaliacao_rascunho);
                        setAulaExtracurricular(detalhe_rascunhoAula.extracurricular_rascunho);
                        setFalta(detalhe_rascunhoAula.falta_rascunho);
                        setGuardarRecorrencia(detalhe_rascunhoAula.is_recorrencia_rascunho);
                        setReorganizacao(detalhe_rascunhoAula.reorganizar_rascunho);
                        setMotivo(detalhe_rascunhoAula.falta_motivo_prof_rascunho);
                        //setDataComp(detalhe_rascunhoAula.dt_inicio_reagendada_rascunho);
                        setDataComp(
                            detalhe_rascunhoAula.dt_inicio_reagendada_rascunho
                                ? moment(detalhe_rascunhoAula.dt_inicio_reagendada_rascunho)
                                : null
                        );
                        setHoraInicioComp(
                            detalhe_rascunhoAula.hr_inicio_reagendada_rascunho
                                ? moment(detalhe_rascunhoAula.hr_inicio_reagendada_rascunho, "HH:mm")
                                : null
                        );

                        setHoraTerminoComp(
                            detalhe_rascunhoAula.hr_termino_reagendada_rascunho
                                ? moment(detalhe_rascunhoAula.hr_termino_reagendada_rascunho, "HH:mm")
                                : null
                        );
                        setReagendar(detalhe_rascunhoAula.is_reagendada_rascunho);

                        setBackup({
                            data: moment(detalhe_rascunhoAula.dt_inicio_rascunho),
                            horaInicio: moment(detalhe_rascunhoAula.hr_inicio_rascunho, "HH:mm"),
                            horaTermino: moment(detalhe_rascunhoAula.hr_termino_rascunho, "HH:mm"),
                            cargaHoraria: cargaHoraria,
                            dataComp: detalhe_rascunhoAula.dt_inicio_reagendada_rascunho
                                ? moment(detalhe_rascunhoAula.dt_inicio_reagendada_rascunho)
                                : null,
                            horaInicioComp: detalhe_rascunhoAula.hr_inicio_reagendada_rascunho
                                ? moment(detalhe_rascunhoAula.hr_inicio_reagendada_rascunho, "HH:mm")
                                : null,
                            horaTerminoComp: detalhe_rascunhoAula.hr_termino_reagendada_rascunho
                                ? moment(detalhe_rascunhoAula.hr_termino_reagendada_rascunho, "HH:mm")
                                : null,
                            cargaHorariaComp: detalhe_rascunhoAula.carga_horaria_reagendada ?? undefined,
                            professorId: detalhe_rascunhoAula.id_professor_rascunho,
                            salaId: detalhe_rascunhoAula.id_sala_rascunho,
                            observacoes: detalhe_rascunhoAula.titulo_rascunho || "",
                            aulaAvaliacao: detalhe_rascunhoAula.avaliacao_rascunho,
                            aulaExtracurricular: detalhe_rascunhoAula.extracurricular_rascunho,
                            falta: detalhe_rascunhoAula.falta_rascunho,
                            guardarRecorrencia: detalhe_rascunhoAula.is_recorrencia_rascunho,
                            motivo: detalhe_rascunhoAula.falta_motivo_prof_rascunho
                        });

                        backupRascunhoRef.current = {
                            ...backupRascunhoRef.current,
                            data: moment(detalhe_rascunhoAula.dt_inicio_rascunho),
                            horaInicio: moment(detalhe_rascunhoAula.hr_inicio_rascunho, "HH:mm"),
                            horaTermino: moment(detalhe_rascunhoAula.hr_termino_rascunho, "HH:mm"),
                            professorId: detalhe_rascunhoAula.id_professor_rascunho,
                            salaId: detalhe_rascunhoAula.id_sala_rascunho,
                            observacoes: detalhe_rascunhoAula.titulo_rascunho || "",
                            aulaAvaliacao: detalhe_rascunhoAula.avaliacao_rascunho,
                            aulaExtracurricular: detalhe_rascunhoAula.extracurricular_rascunho,
                            falta: detalhe_rascunhoAula.falta_rascunho,
                            guardarRecorrencia: detalhe_rascunhoAula.is_recorrencia_rascunho,
                            reorganizacao: detalhe_rascunhoAula.reorganizar_rascunho,
                            motivo: detalhe_rascunhoAula.falta_motivo_prof_rascunho,
                            reagendar: false
                        };
                    },
                    onCancel: cancelarRascunho
                });
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar rascunho!");
            });
    };

    // ✅ Função para verificar se houve alteração
    const verificarAlteracao = useCallback(() => {
        const backup = backupRascunhoRef.current;

        // Normaliza valores para comparação
        const normalize = val => {
            if (val === null || val === undefined) return null;
            if (typeof val === "string") return val.trim();
            if (moment.isMoment(val)) return val.format("YYYY-MM-DD HH:mm");
            return val;
        };

        const atual = {
            data: normalize(data),
            horaInicio: normalize(horaInicio),
            horaTermino: normalize(horaTermino),
            dataComp: normalize(dataComp),
            horaInicioComp: normalize(horaInicioComp),
            horaTerminoComp: normalize(horaTerminoComp),
            professorId: professorId,
            salaId: salaId,
            observacoes: normalize(observacoes),
            aulaAvaliacao: aulaAvaliacao,
            aulaExtracurricular: aulaExtracurricular,
            falta: falta,
            guardarRecorrencia: guardarRecorrencia,
            reorganizacao: reorganizacao,
            motivo: normalize(motivo),
            reagendar: reagendar
        };

        const backupNormalizado = {
            data: normalize(backup.data),
            horaInicio: normalize(backup.horaInicio),
            horaTermino: normalize(backup.horaTermino),
            dataComp: normalize(backup.dataComp),
            horaInicioComp: normalize(backup.horaInicioComp),
            horaTerminoComp: normalize(backup.horaTerminoComp),
            professorId: backup.professorId,
            salaId: backup.salaId,
            observacoes: normalize(backup.observacoes),
            aulaAvaliacao: backup.aulaAvaliacao,
            aulaExtracurricular: backup.aulaExtracurricular,
            falta: backup.falta,
            guardarRecorrencia: backup.guardarRecorrencia,
            reorganizacao: backup.reorganizacao,
            motivo: normalize(backup.motivo),
            reagendar: backup.reagendar
        };

        // Compara todos os campos
        return JSON.stringify(atual) !== JSON.stringify(backupNormalizado);
    }, [
        data,
        horaInicio,
        horaTermino,
        dataComp,
        horaInicioComp,
        horaTerminoComp,
        professorId,
        salaId,
        observacoes,
        aulaAvaliacao,
        aulaExtracurricular,
        falta,
        guardarRecorrencia,
        reorganizacao,
        motivo,
        reagendar
    ]);

    const guardarRascunhoAula = async () => {
        const aulaId = localStorage.getItem("aula_diario");

        if (!aulaId) return;
        if (!data || !horaInicio || !horaTermino) return;

        const houveAlteracao = verificarAlteracao();

        if (!houveAlteracao) {
            openNotificationWithIcon(
                "error",
                "Erro ao guardar",
                "Ocorreu um problema ao guardar o rascunho dos conteúdos. Tente novamente."
            );
            return;
        }

        const hr_inicio = moment(horaInicio).utc().format("HH:mm");
        const hr_termino = moment(horaTermino).utc().format("HH:mm");

        const item = new FormData();
        item.append("id", aulaId);
        item.append("dt_inicio", data.format("YYYY/MM/DD"));
        item.append("hr_inicio", hr_inicio);
        item.append("hr_termino", hr_termino);

        if (dataComp) item.append("dt_inicio_reagendada", moment(dataComp).format("YYYY/MM/DD"));
        if (horaInicioComp) item.append("hr_inicio_reagendada", horaInicioComp.format("HH:mm"));
        if (horaTerminoComp) item.append("hr_termino_reagendada", horaTerminoComp.format("HH:mm"));

        if (professorId !== undefined && professorId !== null) {
            item.append("id_professor", professorId);
        }
        if (salaId !== undefined && salaId !== null) {
            item.append("id_sala", salaId);
        }
        if (observacoes !== undefined && observacoes !== null && observacoes !== "") {
            item.append("titulo", observacoes);
        }

        item.append("avaliacao", aulaAvaliacao);
        item.append("extracurricular", aulaExtracurricular);
        item.append("falta", falta);
        item.append("is_recorrencia", guardarRecorrencia);
        item.append("is_reagendada", reagendar);
        item.append("reorganizar", reorganizacao);
        if (motivo !== undefined && motivo !== null && motivo !== "") {
            item.append("falta_motivo_prof", motivo);
        }
        if (dataComp) item.append("dt_inicio_reagendada", moment(dataComp).format("YYYY/MM/DD"));

        axios({
            method: "put",
            url: "/api/aulas/rascunho-detalhe-aula",
            data: item
        })
            .then(() => {
                backupRascunhoRef.current = {
                    data: data,
                    horaInicio: horaInicio,
                    horaTermino: horaTermino,
                    dataComp: dataComp,
                    horaInicioComp: horaInicioComp,
                    horaTerminoComp: horaTerminoComp,
                    professorId: professorId,
                    salaId: salaId,
                    observacoes: observacoes,
                    aulaAvaliacao: aulaAvaliacao,
                    aulaExtracurricular: aulaExtracurricular,
                    falta: falta,
                    guardarRecorrencia: guardarRecorrencia,
                    reorganizacao: reorganizacao,
                    motivo: motivo,
                    reagendar: reagendar
                };

                // ✅ SÓ atualiza context se houve alteração
                globalContext.atualizarState({
                    existeRascunhoGuardado: true
                });
            })
            .catch(e => {
                openNotificationWithIcon(
                    "error",
                    "Erro ao guardar",
                    "Ocorreu um problema ao guardar o rascunho dos conteúdos. Tente novamente."
                );
                /*this.setState({ iconLoading: false });
                this.context.atualizarState({
                    existeRascunhoGuardado: false
                });*/
                globalContext.atualizarState({
                    existeRascunhoGuardado: false
                });
                console.error("Erro ao guardar rascunho detalhe aula: ", e);
            });
    };

    const tentarGuardarRascunho = useCallback(() => {
        if (!alteradoPeloUserRef.current) return;
        guardarRascunhoAula();
        alteradoPeloUserRef.current = false;
    }, [
        horaInicio,
        horaTermino,
        professorId,
        salaId,
        observacoes,
        aulaAvaliacao,
        aulaExtracurricular,
        falta,
        guardarRecorrencia,
        reorganizacao,
        motivo,
        dataComp,
        horaInicioComp,
        horaTerminoComp,
        reagendar
    ]);

    useEffect(() => {
        clearTimeout(autoSaveTimeoutRef.current);

        autoSaveTimeoutRef.current = setTimeout(() => {
            tentarGuardarRascunho();
        }, 1000);

        return () => clearTimeout(autoSaveTimeoutRef.current);
    }, [
        horaInicio,
        horaTermino,
        professorId,
        salaId,
        observacoes,
        aulaAvaliacao,
        aulaExtracurricular,
        falta,
        guardarRecorrencia,
        reorganizacao,
        motivo,
        dataComp,
        horaInicioComp,
        horaTerminoComp,
        reagendar
    ]);

    useEffect(() => {
        rascunhoCarregadoRef.current = false;
        alteradoPeloUserRef.current = false;

        listarProfessores();
        listarSalas();
        validarPermissao();
        carregarDetalhe();
    }, [aulaId]);

    useEffect(() => {
        listarProfessores();
        listarSalas();
        validarPermissao();
    }, [globalContext.estabelecimento]);

    useEffect(() => {
        if (horaInicio != null && horaTermino != null) calcularCargaHoraria();

        if (horaInicioComp != null && horaTerminoComp != null) calcularCargaHorariaComp();
    }, [horaInicio, horaTermino, horaInicioComp, horaTerminoComp]);

    useEffect(() => {
        rascunhoCarregadoRef.current = false;
        alteradoPeloUserRef.current = false;

        // ✅ Reset do backup também
        backupRascunhoRef.current = {
            data: null,
            horaInicio: null,
            horaTermino: null,
            dataComp: null,
            horaInicioComp: null,
            horaTerminoComp: null,
            professorId: null,
            salaId: null,
            observacoes: "",
            aulaAvaliacao: false,
            aulaExtracurricular: false,
            falta: false,
            guardarRecorrencia: false,
            reorganizacao: false,
            motivo: "",
            reagendar: false
        };
    }, [aulaId]);

    if (redirect) return <Redirect to={redirectLink} />;

    const acesso = globalContext.acessos?.find(x => x.func === 17);

    const canalIranduba = localStorage.getItem("entidade_id") === "33";

    return (
        <>
            <Form className="form-categorias" layout="horizontal">
                <div className="bloco">
                    <Row>
                        <Col span={12}>
                            <div className="gutter-box">
                                <Form.Item
                                    label={
                                        <>
                                            <label>
                                                Aula
                                                {!reagendada && foraPeriodo && !extracurricular && (
                                                    <span className="aula-problemas">
                                                        <Icon type="warning" title="Aula fora do periodo" />
                                                    </span>
                                                )}
                                            </label>
                                            {!reagendada && acesso?.update && (
                                                <span style={{ marginLeft: 60, display: "inline-flex", gap: 5 }}>
                                                    {!reagendada && (
                                                        <button
                                                            className="botao-editar"
                                                            disabled={editar || reagendar}
                                                            style={{
                                                                height: 20,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                padding: 10,
                                                                fontSize: 11
                                                            }}
                                                            onClick={() => {
                                                                setEditar(true);
                                                                criarBackup();
                                                            }}
                                                            type="primary"
                                                        >
                                                            Editar
                                                        </button>
                                                    )}
                                                    <button
                                                        className="botao-editar"
                                                        disabled={editar || reagendar}
                                                        style={{
                                                            height: 20,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            padding: 10,
                                                            fontSize: 11
                                                        }}
                                                        onClick={() => {
                                                            setReagendar(true);
                                                            criarBackup();
                                                        }}
                                                        type="primary"
                                                    >
                                                        Reagendar
                                                    </button>
                                                </span>
                                            )}
                                        </>
                                    }
                                >
                                    {getFieldDecorator("data", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ],
                                        initialValue: data
                                    })(
                                        <DatePicker
                                            className="input-50"
                                            placeholder="Selecionar"
                                            format="DD-MM-YYYY"
                                            name="data"
                                            onChange={data => {
                                                alteradoPeloUserRef.current = true;
                                                setData(data);
                                                apanharUltimaHora(true, data);
                                            }}
                                            disabled={!editar || reagendada}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span style={{ display: "inline-flex", alignItems: "center" }}>
                                            <span>Hora Inicio</span>
                                            {!reagendada && duplicada && ((canalIranduba && !extracurricular) || !canalIranduba) && (
                                                <span className="aula-problemas" style={{ display: "inline-flex" }}>
                                                    <Icon type="warning" title="Aula sobreposta" />
                                                </span>
                                            )}
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("horaInicio", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ],
                                        initialValue: horaInicio
                                    })(
                                        <TimePicker
                                            className="input-50"
                                            name="horaInicio"
                                            defaultOpenValue={moment("00:00", "HH:mm")}
                                            format="HH:mm"
                                            placeholder="Selecionar"
                                            disabled={!editar || reagendada}
                                            onChange={handleChangeHoraInicio}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span style={{ display: "inline-flex", alignItems: "center" }}>
                                            <span>Hora Término</span>
                                            {!reagendada && duplicada && ((canalIranduba && !extracurricular) || !canalIranduba) && (
                                                <span className="aula-problemas" style={{ display: "inline-flex" }}>
                                                    <Icon type="warning" title="Aula sobreposta" />
                                                </span>
                                            )}
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("horaTermino", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Campo obrigatório"
                                            }
                                        ],
                                        initialValue: horaTermino
                                    })(
                                        <TimePicker
                                            className="input-50"
                                            name="horaTermino"
                                            defaultOpenValue={moment("00:00", "HH:mm")}
                                            format="HH:mm"
                                            placeholder="Selecionar"
                                            onChange={horaTermino => {
                                                alteradoPeloUserRef.current = true;
                                                setHoraTermino(horaTermino);
                                            }}
                                            disabled={!editar || reagendada}
                                        />
                                    )}
                                    {cargaHoraria && (
                                        <div style={{ borderTop: "1px solid #d9d9d9", marginTop: 10, paddingTop: 5, width: "50%" }}>
                                            <span style={{ display: "block", lineHeight: "initial" }}>
                                                <strong>Carga Horária:</strong> {cargaHoraria}
                                                {/*{!reagendada && cargaAcima && (*/}
                                                {/*    <span className="aula-problemas">*/}
                                                {/*        <Icon type="warning" title="Carga horária acima do limite de 5 horas" />*/}
                                                {/*    </span>*/}
                                                {/*)}*/}
                                            </span>
                                        </div>
                                    )}
                                </Form.Item>
                            </div>
                        </Col>
                        {(reagendar || reagendada) && (
                            <Col span={12}>
                                <div className="gutter-box">
                                    <Form.Item
                                        label={
                                            <>
                                                <label>
                                                    Aula Reagendada
                                                    {reagendada && foraPeriodo && !aulaExtracurricular && (
                                                        <span className="aula-problemas">
                                                            <Icon type="warning" title="Aula fora do periodo" />
                                                        </span>
                                                    )}
                                                </label>
                                                {reagendada && acesso?.update && (
                                                    <span style={{ marginLeft: 70, display: "inline-flex", gap: 5 }}>
                                                        <button
                                                            className="botao-editar"
                                                            disabled={reagendar}
                                                            style={{
                                                                height: 20,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                padding: 10,
                                                                fontSize: 11
                                                            }}
                                                            onClick={() => {
                                                                setReagendar(true);
                                                                criarBackup();
                                                            }}
                                                            type="primary"
                                                        >
                                                            Editar
                                                        </button>
                                                    </span>
                                                )}
                                            </>
                                        }
                                    >
                                        {getFieldDecorator("dataComp", {
                                            rules: [
                                                {
                                                    required: reagendar,
                                                    message: "Campo obrigatório"
                                                }
                                            ],
                                            initialValue: dataComp
                                        })(
                                            <DatePicker
                                                className="input-50"
                                                placeholder="Selecionar"
                                                format="DD-MM-YYYY"
                                                name="dataComp"
                                                onChange={data => {
                                                    alteradoPeloUserRef.current = true;

                                                    setDataComp(data);
                                                    apanharUltimaHora(false, data);
                                                }}
                                                disabled={!reagendar}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span style={{ display: "inline-flex", alignItems: "center" }}>
                                                <span>Hora Inicio</span>
                                                {reagendada && duplicada && ((canalIranduba && !extracurricular) || !canalIranduba) && (
                                                    <span className="aula-problemas" style={{ display: "inline-flex" }}>
                                                        <Icon type="warning" title="Aula sobreposta" />
                                                    </span>
                                                )}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("horaInicioComp", {
                                            rules: [
                                                {
                                                    required: reagendar,
                                                    message: "Campo obrigatório"
                                                }
                                            ],
                                            initialValue: horaInicioComp
                                        })(
                                            <TimePicker
                                                className="input-50"
                                                name="horaInicioComp"
                                                defaultOpenValue={moment("00:00", "HH:mm")}
                                                format="HH:mm"
                                                onChange={horaInicioComp => {
                                                    alteradoPeloUserRef.current = true;
                                                    handleChangeHoraInicioComp(horaInicioComp);
                                                }}
                                                placeholder="Selecionar"
                                                suffixIcon={false}
                                                clearIcon={false}
                                                disabled={!reagendar}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span style={{ display: "inline-flex", alignItems: "center" }}>
                                                <span>Hora Término</span>
                                                {reagendada && duplicada && ((canalIranduba && !extracurricular) || !canalIranduba) && (
                                                    <span className="aula-problemas" style={{ display: "inline-flex" }}>
                                                        <Icon type="warning" title="Aula sobreposta" />
                                                    </span>
                                                )}
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("horaTerminoComp", {
                                            rules: [
                                                {
                                                    required: reagendar,
                                                    message: "Campo obrigatório"
                                                }
                                            ],
                                            initialValue: horaTerminoComp
                                        })(
                                            <TimePicker
                                                className="input-50"
                                                name="horaTerminoComp"
                                                defaultOpenValue={moment("00:00", "HH:mm")}
                                                format="HH:mm"
                                                onChange={horaTerminoComp => {
                                                    alteradoPeloUserRef.current = true;
                                                    setHoraTerminoComp(horaTerminoComp);
                                                }}
                                                placeholder="Selecionar"
                                                suffixIcon={false}
                                                clearIcon={false}
                                                disabled={!reagendar}
                                            />
                                        )}
                                        {cargaHorariaComp && (
                                            <div style={{ borderTop: "1px solid #d9d9d9", marginTop: 10, paddingTop: 5, width: "50%" }}>
                                                <span style={{ display: "block", lineHeight: "initial" }}>
                                                    <strong>Carga Horária:</strong> {cargaHorariaComp}
                                                </span>
                                            </div>
                                        )}
                                    </Form.Item>
                                </div>
                            </Col>
                        )}
                    </Row>
                    {permissao && (
                        <Form.Item label="Professor">
                            {getFieldDecorator("professor", {
                                initialValue: professorId
                            })(
                                <Select
                                    placeholder="Selecionar"
                                    disabled={!editar && !reagendar}
                                    onChange={professorId => {
                                        alteradoPeloUserRef.current = true;
                                        setProfessorId(professorId);
                                    }}
                                >
                                    {listaProfessores.map(professor => (
                                        <Option key={professor.id} value={professor.id}>
                                            {professor.nome}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    )}
                    {localStorage.getItem("entidade_id") !== "33" && (
                        <Form.Item label="Sala">
                            {getFieldDecorator("sala", {
                                initialValue: salaId
                            })(
                                <Select
                                    placeholder="Selecionar"
                                    disabled={!editar && !reagendar}
                                    onChange={salaId => {
                                        alteradoPeloUserRef.current = true;
                                        setSalaId(salaId);
                                    }}
                                >
                                    {listaSalas.map(sala => (
                                        <Option key={sala.id} value={sala.id}>
                                            {sala.nome}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    )}
                    <Form.Item label="Observações">
                        {getFieldDecorator("observacoes", {
                            initialValue: observacoes
                        })(
                            <TextArea
                                name="observacoes"
                                disabled={!editar && !reagendar}
                                onChange={event => {
                                    alteradoPeloUserRef.current = true;
                                    setObservacoes(event.target.value);
                                }}
                                rows={4}
                                style={{ height: 100 }}
                            />
                        )}
                    </Form.Item>
                    <Form.Item>
                        <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <Switch
                                size="small"
                                checked={aulaAvaliacao}
                                disabled={!editar && !reagendar}
                                onChange={avaliacao => {
                                    alteradoPeloUserRef.current = true;
                                    setAulaAvaliacao(avaliacao);
                                }}
                            />
                            Aula de avaliação
                        </span>
                        {localStorage.getItem("entidade_id") !== "33" && (
                            <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <Switch
                                    size="small"
                                    checked={aulaExtracurricular}
                                    disabled={!editar && !reagendar}
                                    onChange={extracurricular => {
                                        alteradoPeloUserRef.current = true;
                                        setAulaExtracurricular(extracurricular);
                                    }}
                                />
                                Aula extracurricular
                            </span>
                        )}
                        <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <Switch
                                size="small"
                                checked={falta}
                                disabled={!editar && !reagendar}
                                onChange={falta => {
                                    alteradoPeloUserRef.current = true;
                                    setFalta(falta);
                                }}
                            />
                            Falta
                        </span>
                        {codigoRecorrencia == undefined ? (
                            <></>
                        ) : (
                            <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <Switch
                                    size="small"
                                    checked={guardarRecorrencia == undefined ? setGuardarRecorrencia(false) : guardarRecorrencia}
                                    disabled={!editar || reagendar}
                                    onChange={recorrencia => {
                                        alteradoPeloUserRef.current = true;
                                        setGuardarRecorrencia(recorrencia);
                                    }}
                                />
                                Salvar para recorrencia
                            </span>
                        )}
                        <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <Switch
                                size="small"
                                checked={reorganizacao}
                                disabled={!editar && !reagendar}
                                onChange={reorganizacao => {
                                    alteradoPeloUserRef.current = true;
                                    setReorganizacao(reorganizacao);
                                }}
                            />
                            Reorganização
                        </span>
                    </Form.Item>
                    {falta && (
                        <Form.Item label="Motivo">
                            {getFieldDecorator("motivo", {
                                initialValue: motivo
                            })(
                                <TextArea
                                    name="motivo"
                                    disabled={!editar && !reagendar}
                                    onChange={event => {
                                        alteradoPeloUserRef.current = true;
                                        setMotivo(event.target.value);
                                    }}
                                    rows={4}
                                    style={{ height: 100 }}
                                />
                            )}

                            {getFieldDecorator("download", {
                                rules: [
                                    {
                                        validator: validar
                                    }
                                ],
                                initialValue: ficheiro
                            })(
                                <>
                                    <Dragger style={{ marginTop: "7px" }} {...propsFileUpload} fileList={ficheiro}>
                                        <p className="ant-upload-drag-icon">
                                            <i className="fas fa-upload" />
                                        </p>
                                        <p className="ant-upload-text">
                                            Adicionar anexo
                                            <Tooltip title="Formatos válidos: .zip, .rar, .7z, .docx, .doc, .pdf, .odf, .txt, .rtf, .xlsx, .xls, .csv, .ods, .pptx, .ppt, .odp, .bmp, .gif, .png, .jpeg, .jpg">
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </p>
                                        <p className="ant-upload-hint">Limite de 25MB por upload</p>
                                    </Dragger>
                                </>
                            )}
                        </Form.Item>
                    )}
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                    {(editar || reagendar) && acesso?.update && (
                        <>
                            {codigoMultisseriado && (
                                <button className="botao-principal" onClick={() => guardar(true)} disabled={loading} type="primary">
                                    {loading ? <Icon type="loading" /> : null}
                                    Salvar Multisseriado
                                </button>
                            )}
                            <button className="botao-principal" onClick={() => guardar(false)} disabled={loading} type="primary">
                                {loading ? <Icon type="loading" /> : null}
                                Salvar
                            </button>
                            <button
                                className="botao-secundario"
                                onClick={() => {
                                    setEditar(false);
                                    setReagendar(false);
                                    usarBakcup();
                                }}
                                type="primary"
                            >
                                Cancelar
                            </button>
                        </>
                    )}
                    {(duplicada || foraPeriodo) && !editar && !reagendar && acesso?.update && (
                        <button className="botao-principal" onClick={confirmar} disabled={loading} type="primary">
                            Confirmar
                        </button>
                    )}
                </div>
            </Form>
        </>
    );
};

const FormDetalhe = Form.create({ name: "form-detalhe" })(Detalhe);

export default withRouter(FormDetalhe);
